import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { NotificationService } from 'src/app/core/notification.service';
import { StrikeService } from 'src/app/core/strike.service';
import { ApiResponse } from 'src/app/shared/interfaces/api-response';
import { NewStrike } from 'src/app/shared/interfaces/new-strike';

@Component({
  selector: 'app-new-strike',
  templateUrl: './new-strike.component.html',
  styleUrls: ['./new-strike.component.css']
})
export class NewStrikeComponent {
  disableButton = false;

  newStrikeForm = new FormGroup({
    title: new FormControl('', {validators: Validators.required, nonNullable: true}),
    startDate: new FormControl('', {validators: Validators.required, nonNullable: true}),
    endDate: new FormControl('', {nonNullable: true}),
    minThresholdHours: new FormControl('', {validators: Validators.required, nonNullable: true}),
    minThresholdDays: new FormControl('', {validators: Validators.required, nonNullable: true}),
    participationBenefitAmt: new FormControl('', {validators: Validators.required, nonNullable: true}),
    helperBenefitAmt: new FormControl('', {validators: Validators.required, nonNullable: true}),
    lastWeekMinThresholdHours: new FormControl('', {validators: Validators.required, nonNullable: true}),
    lastWeekMinThresholdDays: new FormControl('', {validators: Validators.required, nonNullable: true}),
    lastWeekParticipationBenefitAmt: new FormControl('', {validators: Validators.required, nonNullable: true}),
    lastWeekHelperBenefitAmt: new FormControl('', {validators: Validators.required, nonNullable: true}),
    comments: new FormControl('', {validators: Validators.required, nonNullable: true})
  },)

  // these getters are needed for the form validation in the html https://angular.io/guide/form-validation#:~:text=as%20an%20array.-,This,-example%20also%20adds
  get title() { return this.newStrikeForm.get('title')}
  get startDate() { return this.newStrikeForm.get('startDate')}
  get minThresholdHours() { return this.newStrikeForm.get('minThresholdHours')}
  get minThresholdDays() { return this.newStrikeForm.get('minThresholdDays')}
  get participationBenefitAmt() { return this.newStrikeForm.get('participationBenefitAmt')}
  get helperBenefitAmt() { return this.newStrikeForm.get('helperBenefitAmt')}
  get lastWeekMinThresholdHours() { return this.newStrikeForm.get('lastWeekMinThresholdHours')}
  get lastWeekMinThresholdDays() { return this.newStrikeForm.get('lastWeekMinThresholdDays')}
  get lastWeekParticipationBenefitAmt() { return this.newStrikeForm.get('lastWeekParticipationBenefitAmt')}
  get lastWeekHelperBenefitAmt() { return this.newStrikeForm.get('lastWeekHelperBenefitAmt')}
  get comments() { return this.newStrikeForm.get('comments')}

  constructor(
    private datepipe: DatePipe, 
    private strikes: StrikeService, 
    private notification: NotificationService,
    private router: Router
    ) { }

  async submitNewStrike() {

    this.disableButton = true;

    const formattedStartDate: string | null = this.datepipe.transform(
      this.newStrikeForm.value.startDate,
      "yyyy-MM-dd",
    );


    const formattedEndDate: string | null = this.datepipe.transform(
      this.newStrikeForm.value.endDate,
      "yyyy-MM-dd",
    );

    if (typeof(formattedStartDate) != 'string') {
      this.notification.displayError('Please fill out all fields')
      return
    }

    const newStrike: NewStrike = {
      title: this.newStrikeForm.getRawValue().title,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      minThresholdHours: this.newStrikeForm.getRawValue().minThresholdHours,
      minThresholdDays: this.newStrikeForm.getRawValue().minThresholdDays,
      participationBenefitAmt: this.newStrikeForm.getRawValue().participationBenefitAmt,
      helperBenefitAmt: this.newStrikeForm.getRawValue().helperBenefitAmt,
      lastWeekMinThresholdHours: this.newStrikeForm.getRawValue().lastWeekMinThresholdHours,
      lastWeekMinThresholdDays: this.newStrikeForm.getRawValue().lastWeekMinThresholdDays,
      lastWeekParticipationBenefitAmt: this.newStrikeForm.getRawValue().lastWeekParticipationBenefitAmt,
      lastWeekHelperBenefitAmt: this.newStrikeForm.getRawValue().lastWeekHelperBenefitAmt,
      comments: this.newStrikeForm.getRawValue().comments
    }

    const response: ApiResponse = await this.strikes.addStrike(newStrike);
    
    if (response.success) {
      this.router.navigateByUrl('/home')
      this.notification.displaySuccess('Strike successfully created')
    }
    else {
      this.notification.displayError('Please make sure all fields are filled out and try again.')
    }
    
    this.disableButton = false;
  }
}
